import { Component } from "react";
import { connect } from "react-redux";
import _ from 'lodash';
import Utils from "../libs/Utils";
import API from '../api';
import history from "../history";
import AuthenticationActions from "../actions/Authentication";
// import UserActions from "../actions/UserOverview";

const PUBLIC_PATHS = ["/", "/landing-page", "/authentication", "/Register", "/forgot-password", "/access-denied", "/404"];
const PUBLIC_PREFIXES = ["/homepage", "/test"];

const isPublicPath = (pathname) => (
    PUBLIC_PATHS.includes(pathname)
    || PUBLIC_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
);

const isAdminPath = (pathname) => (
    pathname.startsWith("/admin") || pathname.startsWith("/limited-admin")
);

class ValidationRoute extends Component {
    constructor() {
        super();
        this.state = {};
    }

    componentDidMount() {
        const { pathname } = history.location;
        if (isPublicPath(pathname)) {
            this._checkAuthenticationForGuestPortal();
        } else {
            this._checkAuthentication();
        }
    }

    static async getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.userData) {
            const oldData = Utils.getSavedUserData();
            const newData = nextProps.userData;
            if (newData && oldData && !_.isEqual(oldData, newData)) {
                Utils.updateSavedUserData("status", _.get(nextProps.userData, "status", oldData.status));
            }
        }
        return null;
    }

    _checkAuthenticationForGuestPortal() {
        const { setUserLogged } = this.props;
        Utils.authenticationValidate({
            found: (access_token) => {
                // const savedUserData = Utils.getSavedUserData();
                // getUserData(savedUserData.id);
                API.setToken(access_token);
                setUserLogged(true);
            },
            notFound: () => {
            }
        });
    }

    _checkAuthentication() {
        const { pathname } = history.location;
        const { setUserLogged } = this.props;
        if (isAdminPath(pathname)) {
            Utils.authenticationValidate({
                found: (access_token) => {
                    const userData = Utils.getSavedUserData();
                    if (userData.role.name.includes("admin")) {
                        API.setToken(access_token);
                        setUserLogged(true);
                    } else {
                        history.push("/access-denied");
                    }
                },
                notFound: () => {
                    history.push("/authentication");
                }
            });
        } else {
            Utils.authenticationValidate({
                found: (access_token) => {
                    // const savedUserData = Utils.getSavedUserData();
                    // getUserData(savedUserData.id);
                    API.setToken(access_token);
                    setUserLogged(true);
                },
                notFound: () => {
                    history.push("/authentication");
                }
            });
        }
    };

    render() {
        return "";
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.UserOverview.selectedExplore
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUserLogged: (isLogged) => dispatch(AuthenticationActions.isLogged(isLogged)),
        // getUserData: (userID) => dispatch(UserActions.getUserExploreById(userID))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidationRoute);
